import { Pill } from "./styles";

interface Props {
  tag: string;
}

export const CommunityTag = ({ tag }: Props) => {
  return <Pill tag={tag}>{tag}</Pill>;
};
